import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { AccountWriteDTO } from '../interfaces/account';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private dataService: DataService) { }

  updateAccount(accountId: number, account: AccountWriteDTO) {
    return this.dataService.updateAccount(accountId, account);
  }
}
